import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProviderBrand, TProviderBrandPayloadUpdate, TProviderBrandResponse, adaptProviderBrandFromResponse, adaptProviderBrandToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_BRAND } from '../../backend-paths';


export const providerBrandUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_PROVIDER_BRAND}/:id`,
	(payload: TProviderBrandPayloadUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ADMIN_PROVIDER_BRAND}/${id}`;
		const dataRequest = adaptProviderBrandToRequest(data);

		return HttpService.put<TProviderBrandResponse>(path, dataRequest).then(result => {
			return adaptProviderBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerBrandUpdateSlice = createSlice({
	name: 'providerBrandUpdateSlice',
	initialState,
	reducers: {
		clearProviderBrandUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerBrandUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerBrandUpdateApi.fulfilled.type]: (state, action: PayloadAction<TProviderBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerBrandUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderBrandUpdateSelector = () => useAppSelector(state => state[providerBrandUpdateSlice.name]);

export const { clearProviderBrandUpdate } = providerBrandUpdateSlice.actions;
